import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Form } from 'react-final-form';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete,
    Switches
} from 'mui-rff';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    DialogActions,
    Button,
    InputAdornment,
    Grid
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { editDriver, editVendor } from '../../../store/actions/vehicleActionCreator';
import * as logger from '../../../logger';
import { connect } from "react-redux";
import { trackDwebEvent } from '../../analytics';
import { editShop } from '../../../store/actions/partiesActionCreator';

const useStyles = makeStyles(() => ({

    brV1: {
        borderRadius: '8px !important'
    },
    dialogTitleV1: {
        paddingLeft: '30px !important',
        paddingRight: '8px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
    },
    closeIcon: {
        color: '#D5D6D9',
        fontSize: 24
    },
    titleV1: {
        fontSize: 20,
        color: '#0b1323',
        fontWeight: 'bold'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    dialogContentV1: {
        backgroundColor: '#F6F6F8',
        paddingLeft: '30px !important',
        paddingRight: '30px !important',
        paddingTop: '24px !important',
        paddingBottom: '32px !important'
    },
    titleV2: {
        fontSize: 12,
        fontWeight: 300,
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.5)',
        textTransform: 'capitalize'
    },
    entityNameV1: {
        fontSize: '16px',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    divContainer: {
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed',
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: 24,
        paddingRight: 24
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    mtV1: {
        marginTop: 4
    },
    dialogActionV1: {
        paddingTop: '20px !important',
        paddingBottom: '20px !important',
        paddingLeft: '30px !important',
        paddingRight: '30px !important',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    closeButtonV1: {
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff) !important',
        textTransform: 'capitalize',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '20px !important',
        paddingRight: '20px !important',
        fontWeight: 600,
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff) !important'
        }
    },
    confirmButtonV1: {
        borderRadius: '4px !important',
        backgroundColor: '#09101e !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '24px !important',
        paddingRight: '24px !important',
        textTransform: 'capitalize',
        color: 'white !important',
        fontWeight: 600,
        marginLeft: 16,
        '&:hover': {
            backgroundColor: '#09101e !important'
        }
    },
    confirmButtonDisabled: {
        borderRadius: '4px !important',
        backgroundColor: '#dadada !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingLeft: '24px !important',
        paddingRight: '24px !important',
        textTransform: 'capitalize',
        color: '#5e636c !important',
        fontWeight: 600,
        marginLeft: 16
    },
    titleV3: {
        color: 'rgba(11, 19, 35, 0.75)',
        fontWeight: 600
    },
    mtV2: {
        marginTop: 24
    }

}));

const AddPhoneNumberDialog = ({ open, onClose, onConfirm, entityData, user, calledFromFlow, type, dispatchEditDriver, dispatchEditSupplier, branchFlow, dispatchEditShop }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [title, setTitle] = useState("");
    const [confirmDisabled, setConfirmDisabled] = useState(true);
    const [phoneNumber, setPhoneNumber] = useState("");

    const tripDetailSingleTrip = user.singleTripData ? user.singleTripData : ""

    const classes = useStyles();

    const initialValues = {
        mobile: phoneNumber ? phoneNumber.replace(/(\d{5})(\d{5})/, "$1-$2").trim() : ""
    }

    useEffect(() => {

        if (calledFromFlow == "onlinePaymentDriver") {
            setTitle("Enter Driver Mobile No");
            trackDwebEvent('Dweb Driver payout Driver phone number backdrop initiated', {
                driver_id: entityData && entityData.id ? entityData.id : "",
                driver_name: entityData && entityData.name ? entityData.name : "",
                driver_balance: entityData && entityData.driverBalance ? entityData.driverBalance : ""
            });
        } else if (calledFromFlow == "onlinePaymentShop") {
            setTitle("Enter Shop Mobile No");
            trackDwebEvent('Dweb Driver payout Shop phone number backdrop initiated', {
                shop_id: entityData && entityData.id ? entityData.id : "",
                shop_name: entityData && entityData.name ? entityData.name : "",
                shop_balance: entityData && entityData.balance ? entityData.balance : ""
            });
        } else if (calledFromFlow == "onlinePaymentSupplier") {
            setTitle("Enter Supplier Mobile No");
            if (branchFlow == "singleTrip") {
                trackDwebEvent('Dweb STP Supplier payout phone number backdrop initiated', {
                    trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                    trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                    supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                    supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                    trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                    vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                    vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                    origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                    destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                    supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : ""
                })
            }
        }

    }, [open]);

    const handleClose = () => {
        setDialogOpen(false);
        onClose();

        if (calledFromFlow == "onlinePaymentDriver") {
            trackDwebEvent('Dweb Driver payout Driver phone number backdrop closed', {
                driver_id: entityData && entityData.id ? entityData.id : "",
                driver_name: entityData && entityData.name ? entityData.name : "",
                driver_balance: entityData && entityData.driverBalance ? entityData.driverBalance : "",
                driver_phone_number: phoneNumber ? phoneNumber : ""
            })
        } else if (calledFromFlow == "onlinePaymentShop") {
            trackDwebEvent('Dweb Shop payout Shop phone number backdrop closed', {
                shop_id: entityData && entityData.id ? entityData.id : "",
                shop_name: entityData && entityData.name ? entityData.name : "",
                shop_balance: entityData && entityData.balance ? entityData.balance : ""
            })
        } else if (calledFromFlow == "onlinePaymentSupplier") {
            if (branchFlow == "singleTrip") {
                trackDwebEvent('Dweb STP Supplier payout phone number backdrop closed', {
                    trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                    trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                    supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                    supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                    trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                    vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                    vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                    origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                    destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                    supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : "",
                    supplier_phone_number: phoneNumber ? phoneNumber : ""
                })
            }
        }
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.mtV2} >
                            <div className={classes.titleV3}>Mobile Number</div>
                            <TextField
                                placeholder="Enter Mobile Number"
                                name="mobile"
                                variant="outlined"
                                size="small"
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                // fieldProps={{
                                //     parse: value => value ? (value.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : ""
                                // }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+91</InputAdornment>
                                }}
                                className={classes.mtV1}
                                classes={{ root: classes.textFieldV1 }}
                            />
                        </div>
                    </>
                )
            }
        ]
    }

    const validate = values => {

        const errors = {}

        let number = values.mobile ? /^[1-9]{1}[0-9]{9}$/.test(values.mobile.replace("-", "")) : "";

        if (!values.mobile) {
            errors.mobile = "Please enter mobile number"
        }

        if (values.mobile && !number) {
            errors.mobile = "Please enter valid 10-digit mobile number."
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;

    }

    const onSubmit = async values => {

        const entityId = entityData && entityData.id ? entityData.id : "";

        if (calledFromFlow == "onlinePaymentDriver") {

            const requestData = {
                contactNumber: values && values.mobile ? values.mobile.replace("-", "") : ""
            }

            dispatchEditDriver(entityId, requestData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Phone Number Dialog Dweb', 'Edit Driver Successfull');
                        trackDwebEvent('Dweb Driver payout Driver phone number backdrop confirmed', {
                            driver_id: entityData && entityData.id ? entityData.id : "",
                            driver_name: entityData && entityData.name ? entityData.name : "",
                            driver_balance: entityData && entityData.driverBalance ? entityData.driverBalance : "",
                            driver_phone_number: data.response && data.response.contactNumber ? data.response.contactNumber : ""
                        });
                        onConfirm();
                    }
                },
                () => {
                    logger.log('Add Phone Number Dialog Dweb', 'Edit Driver Failed');
                }
            )

        } else if (calledFromFlow == "onlinePaymentShop") {

            const requestData = {
                name: entityData && entityData.name ? entityData.name : "",
                contactNumber: values && values.mobile ? values.mobile.replace("-", "") : ""
            }

            dispatchEditShop(entityId, requestData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Phone Number Dialog Dweb', 'Edit Shop Successfull');
                        trackDwebEvent('Dweb Driver payout Shop phone number backdrop confirmed', {
                            shop_id: entityData && entityData.id ? entityData.id : "",
                            shop_name: entityData && entityData.name ? entityData.name : "",
                            shop_balance: entityData && entityData.balance ? entityData.balance : "",
                            shop_phone_number: data.response && data.response.contactNumber ? data.response.contactNumber :values && values.mobile ? values.mobile.replace("-", "") : ""
                        });
                        onConfirm();
                    }
                },
                () => {
                    logger.log('Add Phone Number Dialog Dweb', 'Edit Driver Failed');
                }
            )

        } else if (calledFromFlow == "onlinePaymentSupplier") {

            const requestData = {
                vendorNumber: values && values.mobile ? values.mobile.replace("-", "") : ""
            }

            dispatchEditSupplier(entityId, requestData,
                (data) => {
                    if (data && data.status && data.status.code == 200) {
                        logger.log('Add Phone Number Dialog Dweb', 'Edit Supplier Successfull');
                        onConfirm();
                        if (branchFlow == "singleTrip") {
                            trackDwebEvent('Dweb STP Supplier payout phone number backdrop confirmed', {
                                trip_id: tripDetailSingleTrip && tripDetailSingleTrip.id ? tripDetailSingleTrip.id : "",
                                trip_start_date: tripDetailSingleTrip && tripDetailSingleTrip.startDate ? tripDetailSingleTrip.startDate : "",
                                supplier_id: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.id ? tripDetailSingleTrip.vendor.id : "",
                                supplier_name: tripDetailSingleTrip && tripDetailSingleTrip.vendor && tripDetailSingleTrip.vendor.vendorName ? tripDetailSingleTrip.vendor.vendorName : "",
                                trip_status: tripDetailSingleTrip && tripDetailSingleTrip.status ? tripDetailSingleTrip.status : "",
                                vehicle_id: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.id ? tripDetailSingleTrip.vehicle.id : "",
                                vehicle_number: tripDetailSingleTrip && tripDetailSingleTrip.vehicle && tripDetailSingleTrip.vehicle.number ? tripDetailSingleTrip.vehicle.number : "",
                                origin: tripDetailSingleTrip && tripDetailSingleTrip.startLocation ? tripDetailSingleTrip.startLocation : "",
                                destination: tripDetailSingleTrip && tripDetailSingleTrip.destinationLocation ? tripDetailSingleTrip.destinationLocation : "",
                                supplier_balance: tripDetailSingleTrip && tripDetailSingleTrip.vendorBalance ? tripDetailSingleTrip.vendorBalance : "",
                                supplier_phone_number: values && values.mobile ? values.mobile : ""
                            })
                        }
                    }
                },
                () => {
                    logger.log('Add Phone Number Dialog Dweb', 'Edit Supplier Failed');
                }
            )

        }

    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogOpen}
                classes={{ paperScrollPaper: classes.brV1 }}
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divAlign}>
                        <div className={classes.titleV1}>{title}</div>
                        <div>
                            <IconButton onClick={handleClose}>
                                <CloseIcon className={classes.closeIcon} />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1} >

                    <div className={classes.divContainer}>
                        <div className={classes.titleV2}>{type + ' name'}</div>
                        <div className={classes.entityNameV1}>{entityData.name}</div>
                    </div>

                    <div>
                        <Form
                            onSubmit={onSubmit}
                            keepDirtyOnReinitialize
                            initialValues={initialValues}
                            validate={validate}
                            id="myForm"
                            render={({ handleSubmit, form, submitting, pristine, values }) => {
                                submit = handleSubmit
                                return (
                                    <form onSubmit={handleSubmit} noValidate id="myForm">
                                        <Grid container alignItems="flex-start">
                                            {getFormFields(values).map((item, idx) => item.visible ? (
                                                <Grid item xs={item.size} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ) : null)}
                                        </Grid>
                                    </form>
                                )
                            }}
                        />
                    </div>

                </DialogContent>
                <DialogActions className={classes.dialogActionV1}>
                    <div>
                        <Button variant="contained" className={classes.closeButtonV1} onClick={handleClose} >
                            Close
                        </Button>
                        <Button variant="contained" disabled={confirmDisabled} className={classes.confirmButtonV1} classes={{ disabled: classes.confirmButtonDisabled }}
                            onClick={event => {
                                submit(event)
                            }}
                        >
                            Confirm
                        </Button>
                    </div>
                </DialogActions>

            </Dialog>
        </>
    );
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchEditDriver: (driverId, driverData, onSuccess, onError) => {
        dispatch(editDriver(driverId, driverData, onSuccess, onError));
    },
    dispatchEditSupplier: (id, data, onSuccess, onFailure) => {
        dispatch(editVendor(id, data, onSuccess, onFailure))
    },
    dispatchEditShop: (id, data, onSuccess, onFailure) => {
        dispatch(editShop(id, data, onSuccess, onFailure))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPhoneNumberDialog);